import '../index.css';
import React from 'react';
function Footer() {
  return (
    <footer className="footer">
      <p className="footer__subtitle">© 2022 Mesto Russia</p>
    </footer>
  )
}

export default Footer